import { render, staticRenderFns } from "./PatientEntered.vue?vue&type=template&id=714c116a&scoped=true"
import script from "./PatientEntered.vue?vue&type=script&lang=js"
export * from "./PatientEntered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714c116a",
  null
  
)

export default component.exports